<form [formGroup]="formGroup()" class="row gap-md-0 gap-4">
  <div class="col-12 col-md-4">
    <div class="row gap-4">
      <!-- COMPANY (only for company type) -->
      @if (formGroup().get('companyType')?.value === companyTypeEnum.COMPANY) {
        <div class="col-sm-12">
          <app-form-input [controlName]="'company'"
                          [formGroup]="formGroup()"
                          [id]="'company'"
                          [isRequired]="true"
                          [label]="'COMPANY'"></app-form-input>
        </div>
      }
      <!-- COMPANY TYPE -->
      <div class="col-sm-12">
        <app-enum-select [controlName]="'companyType'"
                         [formGroup]="formGroup()"
                         [enum]="companyTypeEnum"
                         [label]="'CUSTOMERS.COMPANY_TYPE'"
                         [isRequired]="true"
                         [castFunction]="castCompanyType"></app-enum-select>
      </div>
      <!-- CONTACT TYPE (Kontakt/Rechnung/Lieferung/Andere) – nur bei Child-Kontakten, wie in Odoo -->
      @if (isChildContact()) {
        <div class="col-sm-12">
          <app-enum-select [controlName]="'type'"
                           [formGroup]="formGroup()"
                           [enum]="contactTypeEnum"
                           [label]="'CUSTOMERS.CONTACT_TYPE'"
                           [castFunction]="castContactType"></app-enum-select>
        </div>
      }
      <!-- VAT -->
      <div class="col-sm-12">
        <app-form-input [controlName]="'vat'"
                        [formGroup]="formGroup()"
                        [id]="'vat'"
                        [label]="'CUSTOMERS.VAT'"></app-form-input>
      </div>
      <!-- WEBSITE -->
      <div class="col-sm-12">
        <app-form-input [controlName]="'website'"
                        [formGroup]="formGroup()"
                        [id]="'website'"
                        [label]="'CUSTOMERS.WEBSITE'"
                        [type]="'url'"></app-form-input>
      </div>
      <!-- COMPANY REGISTRY (only for company type) -->
      @if (formGroup().get('companyType')?.value === companyTypeEnum.COMPANY) {
        <div class="col-sm-12">
          <app-form-input [controlName]="'companyRegistry'"
                          [formGroup]="formGroup()"
                          [id]="'companyRegistry'"
                          [label]="'CUSTOMERS.COMPANY_REGISTRY'"
                          [type]="'number'"></app-form-input>
        </div>
      }
      <div class="col-sm-12">
        <app-form-input [controlName]="'reference'"
                        [formGroup]="formGroup()"
                        [id]="'reference'"
                        [label]="'CUSTOMERS.REFERENCE'"></app-form-input>
      </div>
      <!-- UNTERNEHMEN (Parent) – read-only beim Kontakt anlegen, sonst Select -->
      @if (parentCustomerForDisplay()) {
        <app-read-only-input [label]="'CUSTOMERS.PARENT_COMPANY'"
                             [value]="parentCustomerForDisplay()!.company"></app-read-only-input>
      } @else {
        <div class="col-sm-12">
          <app-link-select
            [label]="'CUSTOMERS.PARENT_COMPANY'"
            [controlName]="'parent'"
            [formGroup]="formGroup()"
            [optionLabelSelector]="[{ selector: 'company' }]"
            [baseLink]="'customers'"
            [searchValueName]="'company'"
            [queryParams]="[{key: 'company-type', value: 'company'}]"
            [searchService]="customerService"
            [id]="'parent'"
          ></app-link-select>
        </div>
      }
      <!-- LANGUAGE -->
      <div class="col-sm-12">
        <app-form-select [clear]="true"
                         [controlName]="'languageId'"
                         [formGroup]="formGroup()"
                         [id]="'languageId'"
                         [isRequired]="true"
                         [label]="'LANGUAGE'"
                         [optionLabelSelector]="[{ selector: 'name', castFunction: translateValue }]"
                         [optionValueSelector]="'id'"
                         [options]="languageService.models() ?? []"></app-form-select>
      </div>
      <!-- TIMEZONE -->
      <div class="col-sm-12">
        <app-form-select [clear]="true"
                         [controlName]="'timezone'"
                         [filter]="true"
                         [formGroup]="formGroup()"
                         [id]="'timezone'"
                         [label]="'CUSTOMERS.TIMEZONE'"
                         [optionLabelSelector]="[{ selector: 'name' }]"
                         [optionValueSelector]="'name'"
                         [options]="timezones"></app-form-select>
      </div>
      <!-- COMMENT -->
      <div class="col-sm-12">
        <app-text-area-input [controlName]="'comment'"
                             [formGroup]="formGroup()"
                             [id]="'comment'"
                             [label]="'CUSTOMERS.COMMENT'"
                             [rows]="2"></app-text-area-input>
      </div>
      <!-- ACTIVE -->
      <div class="col-sm-12">
        <app-checkbox-input [controlName]="'active'"
                            [formGroup]="formGroup()"
                            [id]="'active'"
                            [checked]="true"
                            [label]="('CUSTOMERS.ACTIVE'|translate)"></app-checkbox-input>
      </div>
      <!-- INDUSTRY (only for company type) -->
      @if (formGroup().get('companyType')?.value === companyTypeEnum.COMPANY) {
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpIndustryId'"
                          [formGroup]="formGroup()"
                          [id]="'erpIndustryId'"
                          [label]="'CUSTOMERS.INDUSTRY'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="industryService"></app-api-select>
        </div>
      }
      <div class="col-sm-12">
        <app-api-select [controlName]="'erpCategoryIds'"
                        [formGroup]="formGroup()"
                        [id]="'erpCategoryIds'"
                        [label]="'CUSTOMERS.CATEGORIES'"
                        [multiple]="true"
                        [optionLabelSelector]="[{ selector: 'name' }]"
                        [optionValueSelector]="'id'"
                        [queryParams]="emptyQueryParams"
                        [searchService]="categoryService"></app-api-select>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="row gap-4">
      <!-- ADDRESS -->
      <div class="col-sm-12"><h5 class="m-0">{{ 'ADDRESS' | translate }}</h5></div>

      <div class="col-sm-12">
        <app-form-input [controlName]="'street'"
                        [formGroup]="getAddressFormGroup()"
                        [id]="'addressStreet'"
                        [label]="'CUSTOMERS.ADDRESSES.STREET'"></app-form-input>
      </div>
      <div class="col-sm-12">
        <app-form-input [controlName]="'houseNumber'"
                        [formGroup]="getAddressFormGroup()"
                        [id]="'addressHouseNumber'"
                        [label]="'CUSTOMERS.ADDRESSES.HOUSE_NUMBER'"></app-form-input>
      </div>
      <div class="col-sm-12">
        <app-form-input [controlName]="'addressSuffix'"
                        [formGroup]="getAddressFormGroup()"
                        [id]="'addressSuffix'"
                        [label]="'CUSTOMERS.ADDRESSES.ADDRESS_SUFFIX'"></app-form-input>
      </div>
      <div class="col-sm-12">
        <app-form-input [controlName]="'postcode'"
                        [formGroup]="getAddressFormGroup()"
                        [id]="'addressPostcode'"
                        [label]="'CUSTOMERS.ADDRESSES.POSTCODE'"></app-form-input>
      </div>
      <div class="col-sm-12">
        <app-form-input [controlName]="'place'"
                        [formGroup]="getAddressFormGroup()"
                        [id]="'addressPlace'"
                        [label]="'CUSTOMERS.ADDRESSES.PLACE'"></app-form-input>
      </div>
      <!-- ADDRESS: COUNTRY -->
      <div class="col-sm-12">
        <app-api-select [controlName]="'erpCountryId'"
                        [formGroup]="getAddressFormGroup()"
                        [id]="'erpCountryId'"
                        [label]="'CUSTOMERS.ADDRESSES.COUNTRY'"
                        [optionLabelSelector]="[{ selector: 'name' }]"
                        [optionValueSelector]="'id'"
                        [queryParams]="emptyQueryParams"
                        [searchService]="countryService"></app-api-select>
      </div>
      @if (getAddressFormGroup().get('erpCountryId')?.value != null && getAddressFormGroup().get('erpCountryId')?.value !== '') {
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpStateId'"
                          [formGroup]="getAddressFormGroup()"
                          [id]="'erpStateId'"
                          [label]="'CUSTOMERS.ADDRESSES.STATE'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="getStateQueryParams()"
                          [searchService]="stateService"></app-api-select>
        </div>
      }


    </div>
  </div>
  <div class="col-12 col-md-4">
    <div class="row gap-4">
      <!-- CONTACT PERSON -->
      <div class="col-sm-12"><h5 class="m-0">{{ 'CONTACT_PERSON' | translate }}</h5></div>

      <!-- Person name and function (only for customer type "person") -->
      @if (formGroup().get('companyType')?.value === companyTypeEnum.PERSON) {
        <div class="col-sm-12">
          <app-form-input [controlName]="'name'"
                          [formGroup]="getPersonFormGroup()"
                          [id]="'personName'"
                          [isRequired]="true"
                          [label]="'CUSTOMERS.PERSON_NAME'"></app-form-input>
        </div>
        <div class="col-sm-12">
          <app-form-input [controlName]="'function'"
                          [formGroup]="getPersonFormGroup()"
                          [id]="'personFunction'"
                          [label]="'CUSTOMERS.PERSON_FUNCTION'"></app-form-input>
        </div>
      }
      <div class="col-sm-12">
        <app-form-input [controlName]="'phoneNumber'"
                        [formGroup]="getPersonFormGroup()"
                        [id]="'phoneNumber'"
                        [label]="'PHONE_NUMBER'"></app-form-input>
      </div>
      <div class="col-sm-12">
        <app-form-input [controlName]="'email'"
                        [formGroup]="getPersonFormGroup()"
                        [id]="'email'"
                        [label]="'EMAIL'"
                        [type]="'email'"></app-form-input>
      </div>
    </div>
  </div>
</form>
